// «السبب» — the reason a reopen (owner) or a reopen request (staff/manager)
// must carry (HANDOFF §5.8: «Reopen: owner only, with a reason, logged»).
// The reason sheet is not drawn (spec board 7 §6, PROPOSED single textarea).

import { Field } from '@/components';
import { CLOSE_COPY } from './copy';

export interface ReasonFieldProps {
  value: string;
  onChange: (v: string) => void;
  error?: string | null;
  disabled?: boolean;
  autoFocus?: boolean;
}

export function ReasonField({ value, onChange, error, disabled, autoFocus }: ReasonFieldProps) {
  return (
    <Field label={CLOSE_COPY.reasonLabel} error={error ?? undefined}>
      {(id) => (
        <span className="e-input bc-textarea" data-invalid={error ? 'true' : undefined}>
          <textarea
            id={id}
            rows={3}
            maxLength={500}
            value={value}
            disabled={disabled}
            autoFocus={autoFocus}
            aria-invalid={error ? true : undefined}
            aria-required="true"
            onChange={(e) => onChange(e.target.value)}
          />
        </span>
      )}
    </Field>
  );
}
